/**
 * The bot's look-ahead: how far it sees, and the numbers every part of it shares.
 *
 * A note on how these are used. The bot's files take local copies of what they import
 * (`const { HORIZON } = horizon`). Under the test runner an imported binding is read through a
 * getter, and the bot's loops read these thousands of times a tick: the copies make it several
 * times faster there and change nothing in the built game.
 */

import { FIELD, FIGHTER } from '../sim';

/** Ticks of look-ahead: a shot crosses the screen in 32, a bomb falls from mid-field in about 40. */
export const HORIZON = 48;
/** A forecast has one entry for now and one for each tick ahead. */
export const STRIDE = HORIZON + 1;
/** The steering lattice: ship positions one tick's flight apart, `HORIZON` of them either side of the start. */
export const COLS = 2 * HORIZON + 1;
/** The distance between two places on the lattice. */
export const PACE = FIGHTER.speed;
/** Where a shot starts (the engine's `fire`). */
export const MUZZLE_Y = FIELD.fighterY - 10;
/** The y of an enemy that is not there: gone, or not yet on stage. */
export const OFF = -1000;
/** More enemies than a stage ever holds; anything past this is ignored. */
export const MAX_ENEMIES = 128;
/** A cell of the danger grid that costs a ship. Anything less is a price for flying close. */
export const LETHAL = 255;
